import {
	Vue, Component, Watch, toNative,
} from 'vue-facing-decorator';
import * as DB from 'interfaces/database';
import { PickerFileMetadata, PickerOptions, PickerResponse } from 'filestack-js';
import { useRoute } from 'vue-router';
import CustomCheckbox from 'components/CustomCheckbox';
import CustomFileInput from 'components/CustomFileInput';
import Model2DService from 'services/Model2DService';
import Template from './EditModel2dTable.vue';

@Component({
	mixins: [Template],
	components: {
		CustomCheckbox,
		CustomFileInput,
	},
})
class EditModel2dTable extends Vue {
	private singleModel2d = {} as DB.Model2DModel;

	private loaded = false;

	private visible = false;

	private spinner = false;

	private imageUrl = '';

	private placeHolders = {
		thumbnailPlaceholder: 'Choose a file',
	};

	private index = 0;

	private isLoading = false;

	private pageOptions = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];

	private route = useRoute();

	get loggedIn(): boolean {
		return this.$auth0.isAuthenticated.value;
	}

	mounted(): void {
		this.getSingleModel2d();
	}

	@Watch('loggedIn')
	async getSingleModel2d(): Promise<DB.Model2DModel | undefined> {
		if (this.loggedIn) {
			// set the loading state
			this.isLoading = true;
			try {
				const resp = await Model2DService.get(this.route.params.id as string);
				this.singleModel2d = resp;
				this.imageUrl = resp.imageUrl;
				// eslint-disable-next-line consistent-return
				return this.singleModel2d;
			} catch (error: any) {
				this.$toastError(error.message);
			} finally {
				this.isLoading = false;
			}
		}
		return undefined;
	}

	editModel2dImage(): Promise<void> | undefined {
		if (this.loggedIn) {
			this.isLoading = true;
			Model2DService.update(
				this.route.params.id as string,
				{ ...this.singleModel2d },
			).then(() => {
				this.$toastSuccess('2D Model Edited successfully');
				return undefined;
			})
				.finally(() => {
					this.isLoading = false;
				})
				.catch((error) => {
					this.$toastError(error.message);
				});
		}
		return undefined;
	}

	//  update image preview
	async updateImagePreview(): Promise<void> {
		const options: PickerOptions = {
			fromSources: ['local_file_system'],
			exposeOriginalFile: true,
			onFileSelected: (file: PickerFileMetadata) => new Promise<void>((resolve) => {
				const blob = file.originalFile;

				// Get an object URL for the local file
				const url = URL.createObjectURL(blob as Blob);

				// Create an image and load the object URL
				const img = new Image();
				img.src = url;

				img.onload = () => {
					URL.revokeObjectURL(url);
					this.singleModel2d.imageHeight = img.height;
					this.singleModel2d.imageWidth = img.width;

					resolve();
				};
			}),
			onUploadDone: async (files: PickerResponse) => {
				this.singleModel2d.imageUrl = files.filesUploaded[0].url;
				this.placeHolders.thumbnailPlaceholder = files.filesUploaded[0].filename;
			},
		};
		this.$client.picker(options).open();
	}

	removeThumbnail(): void {
		this.singleModel2d.imageUrl = '';
		this.imageUrl = '';
	}
}

export default toNative(EditModel2dTable);
